import React from "react";
import { EASAS_REST_URL } from "utils/constants";
import { ScadaProps, TagHighlight } from "../scadaTypes";

export function getScadaImageUrl(scadaBackgroundId: number | undefined) {
    if (!scadaBackgroundId) return '';
    return `${EASAS_REST_URL()}/images/${  scadaBackgroundId}`;
}

export function showCords(el: React.MouseEvent, isEditMode: boolean) {
    if (el.ctrlKey && isEditMode) {
        const tooltip = document.getElementById('simple-tooltip-new') as HTMLDivElement;
        const rect = (el.target as Element)!.getBoundingClientRect();

        const contWidth = rect.width;
        const contHeight = rect.height;
        const x = el.clientX;
            const y = el.clientY;
        tooltip.style.top = `${y + 20  }px`;
        tooltip.style.left = `${x + 20  }px`;

        const relX = el.clientX - rect.left;
        const relY = el.clientY - rect.top;
        const pX = ((relX / contWidth) * 100).toFixed(2);
        const pY = ((relY / contHeight) * 100).toFixed(2);

        tooltip.textContent = `X:${pX}%, Y:${pY}%`;
        tooltip.style.display = 'block';
        tooltip.style.position = 'fixed';
    } else if (!el.ctrlKey || !isEditMode) {
        const tooltip = document.getElementById('simple-tooltip-new') as HTMLDivElement;
        tooltip.style.display = 'none';
    }
}

export const checkValueConditions = (value: number, highlight: TagHighlight) => {
  switch (highlight.condition) {
    case "gt":
      return value > highlight.value;
    case "lt":
      return value < highlight.value;
    case "gte":
      return value >= highlight.value;
    case "lte":
      return value <= highlight.value;
    case "eq":
      return value === highlight.value;
    case "neq":
      return value !== highlight.value;
    default:
      return false;
  }
};

export const tempId = (data: ScadaProps) => `${data.scadaBackgroundId}-${data.refreshRate}-${data.maxDelayTimeUnit}-${data.maxDelayTime}`